import qs from 'qs'

import { BankLineStatus } from '@features/reconciliation/enums'
import { Transaction } from '@features/transactions/types/transaction'
import { BankLine, BankLineMatch } from '@modules-deprecated/bankReconciliation/types'

import { SortDirection } from '../../enums/sortDirection'
import { Metable } from '../../types/metable'
import { getRequest } from '../../utils/api'
import { BankTransactionSortProperty } from './enums/bankTransactionSortProperty'
import { BankLineSubjectAssociationWithSubject } from './types/bankLineSubjectAssociationWithSubject'

export interface BankLinesQueryParams {
  accountId: string
  entryDatePeriod?: string
  isReconciled?: boolean
  maxAmount?: number
  minAmount?: number
  page?: number
  pageSize?: number
  q?: string
  side?: string
  sortDirection?: SortDirection
  sortProperty?: BankTransactionSortProperty
  status?: BankLineStatus
}

export interface BankLinesResponse extends Metable {
  bankLines: BankLine[]
}

export const fetchBankLines = async (params: BankLinesQueryParams): Promise<BankLinesResponse> => {
  const queryParams = { ...params, include: 'bankLine.match:embed' }

  return getRequest(`/v2/bankLines?${qs.stringify(queryParams)}`)
}

export interface FetchBankLineMatchAssociationsResponse extends Metable {
  bankLineSubjectAssociations: BankLineSubjectAssociationWithSubject[]
}

export interface FetchBankLineMatchResponse extends Metable {
  bankLineMatch: BankLineMatch
}

export const fetchBankLineMatch = async (matchId: string): Promise<FetchBankLineMatchResponse> => {
  const queryParams = { include: 'bankLineMatch.lines:embed' }

  return getRequest(`/v2/bankLineMatches/${matchId}?${qs.stringify(queryParams)}`)
}

export const fetchBankLineMatchAssociations = async (
  matchId: string,
): Promise<FetchBankLineMatchAssociationsResponse> => {
  const queryParams = { matchId, include: 'bankLineSubjectAssociation.subject:embed' }

  return getRequest(`/v2/bankLineSubjectAssociations?${qs.stringify(queryParams)}`)
}

export interface FetchTransactionByIdResponse extends Metable {
  transaction: Transaction
}

export const fetchTransactionById = async (transactionId: string): Promise<FetchTransactionByIdResponse> => {
  return getRequest(`/v2/transactions/${transactionId}`)
}
